/**
 * @generated SignedSource<<3bdfa7bbd040b224186efd1d0f3cf341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayVariant_item$data = {
  readonly attributes: {
    readonly framingStatus: ReadonlyArray<{
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPrice_item" | "useItemPriceData_item">;
  readonly " $fragmentType": "PriceDisplayVariant_item";
};
export type PriceDisplayVariant_item$key = {
  readonly " $data"?: PriceDisplayVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplayVariant_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "framingStatus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e259d77984322e80edbb7fa4e9f464f6";

export default node;
